export const generateAnalyticsCodeFromName = (name: string): string =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');

export const getUniqueAnalyticsCode = (
  preferredCode: string,
  usedCodes: Set<string>,
  fallbackSource: string,
): string => {
  const trimmedPreferredCode = preferredCode.trim();
  const baseCode =
    trimmedPreferredCode ||
    generateAnalyticsCodeFromName(fallbackSource) ||
    'item';

  let nextCode = baseCode;
  let suffix = 2;

  while (usedCodes.has(nextCode)) {
    nextCode = `${baseCode}_${suffix}`;
    suffix += 1;
  }

  usedCodes.add(nextCode);

  return nextCode;
};
